import Lightpick from 'lightpick'
import moment from 'moment'
import 'lightpick/css/lightpick.css'

import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'

const SELECTORS = Selectors({
  dateRangeField: 'date-range-field',
  dateSingleField: 'date-single-field',
  datepickerField: 'datepicker',
  dateFrom: 'datepicker--from',
  dateTo: 'datepicker--to',
  dateDisplayField: 'datepicker--display-field',
  dateDisplay: 'datepicker--display span',
})

const $datepickers = document.querySelectorAll(SELECTORS.asClass('datepickerField'))
const $dateSingles = document.querySelectorAll(SELECTORS.asClass('dateSingleField'))
const $dateRanges = document.querySelectorAll(SELECTORS.asClass('dateRangeField'))

const fn = {
  init: () => {
    $dateSingles.forEach($el => {
      const $from = $el.querySelector(SELECTORS.asClass('dateFrom'))
      const $display = $el.querySelector(SELECTORS.asClass('dateDisplay'))

      const picker = new Lightpick({
        parentEl: SELECTORS.asClass('dateSingleField'),
        field: $from,
        hoveringTooltip: false,
        format: 'YYYY-MM-DD',
        minDate: new Date(),
        dropdowns: false,
        onSelect: () => {
          fn.updateDateSingleDisplay(picker, $from, $display)

          $from.closest('form').submit()
        }
      })

      fn.updateDateSingleDisplay(picker, $from, $display)
    })

    $dateRanges.forEach($el => {
      const datesData = $el.dataset.dates ? JSON.parse($el.dataset.dates) : null

      flatpickr($el.querySelector('input[name=date]'), {
        altInput: true,
        mode: 'range',
        altFormat: 'M j, Y',
        onClose: (selectedDates, _, instance) => {
          if (selectedDates.length == 2) {
            const from = instance.formatDate(selectedDates[0], 'Y-m-d')
            const to = instance.formatDate(selectedDates[1], 'Y-m-d')

            window.location.href = `${$el.closest('form').action}?from=${from}&to=${to}`
          }
        },
        onDayCreate: (dObj, dStr, fp, dayElem) => {
          if (datesData && datesData.includes(fp.formatDate(dayElem.dateObj, 'Y-m-d'))) {
            dayElem.classList.add('is-highlighted')
          }
        }
      })
    })

    // $dateRanges.forEach($el => {
    //   const $from = $el.querySelector(SELECTORS.asClass('dateFrom'))
    //   const $to = $el.querySelector(SELECTORS.asClass('dateTo'))
    //   const $display = $el.querySelector(SELECTORS.asClass('dateDisplay'))

    //   const datesData = $el.dataset.dates ? JSON.parse($el.dataset.dates) : null

    //   const picker = new Lightpick({
    //     parentEl: SELECTORS.asClass('dateRangeField'),
    //     field: $from,
    //     secondField: $to,
    //     hoveringTooltip: false,
    //     format: 'YYYY-MM-DD',
    //     repick: false,
    //     dropdowns: false,
    //     onSelect: () => {
    //       if (datesData) {
    //         fn.handleDateHighlight(datesData)
    //       }

    //       fn.updateDateRangeDisplay(picker, $from, $to, $display)

    //       if (picker.getStartDate() && picker.getEndDate()) {
    //         $from.closest('form').submit()
    //       }
    //     },
    //     onOpen: () => {
    //       picker.reset()

    //       if (datesData) {
    //         fn.handleDateHighlight(datesData)
    //       }
    //     }
    //   })

    //   fn.updateDateRangeDisplay(picker, $from, $to, $display)

    //   if (datesData) {
    //     on('mouseup', '.lightpick .lightpick__toolbar button', () => {
    //       fn.handleDateHighlight(datesData)
    //     })
    //   }
    // })
  },

  handleDateHighlight: (dates) => {
    const yearField = document.querySelector('.lightpick__select-years')
    const monthField = document.querySelector('.lightpick__select-months')

    if (yearField && monthField) {
      const year = yearField.value
      const month = monthField.value

      Array.from(document.querySelectorAll('.lightpick__day:not(.is-previous-month):not(.is-next-month):not(.is-highlighted)')).forEach($el => {
        const date = new Date(year, month, $el.textContent)
        const dateStr = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
          .toISOString()
          .split("T")[0]

        if (dates.includes(dateStr)) {
          $el.classList.add('is-highlighted')
        }
      })
    }
  },

  updateDateSingleDisplay: (picker, $from, $display) => {
    if (picker.getStartDate()) {
      $display.innerHTML = `${moment($from.value).format('MMM D, YYYY')}`
      $display.closest(SELECTORS.asClass('dateSingleField')).classList.add('has-value')
    } else {
      $display.innerHTML = $display.dataset.placeholder
    }
  },

  updateDateRangeDisplay: (picker, $from, $to, $display) => {
    if (picker.getStartDate() && picker.getEndDate()) {
      $display.innerHTML = `${moment($from.value).format('MMM D, YYYY')} - ${moment($to.value).format('MMM D, YYYY')}`
      $display.closest(SELECTORS.asClass('dateRangeField')).classList.add('has-value')
    } else {
      $display.innerHTML = $display.dataset.placeholder
    }
  }
}

export default {
  can: () => $datepickers.length,
  run: fn.init
}
